export function setWithExpiry(key, value) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + 1000 * 60 * 60 * 24,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export function setExpiry(key) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = now.getTime() + 1000 * 60 * 10; //1 min
  localStorage.setItem(key, JSON.stringify(item));
}
export function setUserExpiry(key) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = now.getTime() + 1000 * 60 * 60 * 5; //5 hours
  localStorage.setItem(key, JSON.stringify(item));
}
export function getExpiry(key) {
  const expiry = localStorage.getItem(key);
  //console.log({ expiry });
  if (!expiry) {
    return true;
  }
  const now = new Date();
  //console.log(now.getTime(), parseInt(expiry));
  if (now.getTime() > parseInt(expiry)) {
    localStorage.removeItem(key);
    return true;
  }
  return false;
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}